export default __webpack_public_path__ + "static/media/rain.b2557aff.jpg";